import createSweepRuleForSenderRequest from 'owa-service/lib/factory/createSweepRuleForSenderRequest';
import createSweepRuleForSenderOperation from 'owa-service/lib/operation/createSweepRuleForSenderOperation';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
/**
 * Helper function to create the empty rule names array which has the same length of the emailAddresses array.
 * This is a workaround for server validation and will be removed after fixing
 * VSO 8796: Improve validation for utah CreateSweepRuleForSenderAction
 */
function createRuleNames(emailAddresses) {
    return emailAddresses.map(function (email) {
        return format(strings.messagesFrom, email.Name);
    });
}
/**
 * Create sweep rule for sender service request
 * @param emailAddresses the email addresses to be blocked
 * @return the ApplyBulkItemActionResponse
 */
export default function createSweepRuleForSenderService(emailAddresses, destinationFolderId, sourceFolderId, keepNType, keepNCount) {
    var requestBody = createSweepRuleForSenderRequest({
        EmailAddresses: emailAddresses,
        ActionType: 0 /* Move */,
        RuleName: null /* deprecated required param*/,
        RuleNames: createRuleNames(emailAddresses),
        SourceFolderId: { Id: sourceFolderId },
        DestinationFolderId: { Id: destinationFolderId },
        CountType: keepNType,
        KeepNCount: keepNCount,
    });
    return createSweepRuleForSenderOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body;
    });
}
//# sourceMappingURL=createSweepRuleForSenderService.js.map